The event signaling that a `PositionProfile` has been posted.
